import { useEffect } from 'react';

import { getInstance } from '../../services/heartbeat';

const HeartbeatNew = () => {
	useEffect(() => {
		const heartbeatService = getInstance();
		return () => heartbeatService.cleanup();
	}, []);

	return null;
};

export default HeartbeatNew;
